import { gql } from '@apollo/client';

const STUDY_SETTING_FRAGMENT = gql`
  fragment StudySettingFragment on StudySetting {
    duration
    preEventTime
    postEventTime
    bradycardiaThreshold
    tachycardiaThreshold
    pauseLevel
    pauseDetection
    afibDetection
    diagnosticLead
    algAmp
    ringId
  }
`;

export default STUDY_SETTING_FRAGMENT;
